import { StatusPillTypedValueToParams } from '@uigy/shared/components/ui-status-pill/ui-status-pill-typed/ui-status-pill-typed.interfaces';
import { ColorStatus } from '@uigy/shared/components/ui-status-pill/ui-status-pill.enums';
import { IconsEnum } from '@uigy/generated/icons.enum';
import { FindingStatus } from '@uigy/generated/graphql';

export const FindingsStatusPillParams: StatusPillTypedValueToParams = {
  [FindingStatus.Active]: {
    color: ColorStatus.Blue,
    label: 'findings.status.active',
    icon: IconsEnum.alert,
  },
  [FindingStatus.Resurfaced]: {
    color: ColorStatus.Blue,
    label: 'findings.status.resurfaced',
    icon: IconsEnum.resurfaced,
  },
  ['Fixed']: {
    color: ColorStatus.Transparent,
    label: 'findings.status.fixed',
    icon: IconsEnum.fixed,
  },
  [FindingStatus.Resolved]: {
    color: ColorStatus.Green,
    label: 'findings.status.resolved',
    icon: IconsEnum.check_circle,
  },
};
